export default function ItemGrid({
  items = [],
  renderItem,
  className = "",
  gridCols = "grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
}) {
  if (!items || items.length === 0) {
    return (
      <div className="py-12 text-center">
        <p className="text-lg text-gray-500">Henüz öğe bulunmuyor.</p>
      </div>
    );
  }

  return (
    <div className={`grid ${gridCols} gap-4 md:gap-6 ${className}`}>
      {items.map((item, index) => (
        <div key={index}>
          {renderItem ? (
            renderItem(item, index)
          ) : (
            <div className="h-full rounded-lg bg-gray-100 p-4">
              <p className="text-gray-600">{JSON.stringify(item)}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
